import { PaperConfigMissing } from "@components/ui_v2";

export const TabGarantia = () => <PaperConfigMissing />;
